<div [formGroup]="form" kalDialogContent>

    <div class="flexLine date">

        <kal-form-field class="date-heure">

            <kal-datepicker formControlName="dateStart"
                            [label]="data.dateStartLabel">
            </kal-datepicker>

            <kal-input *ngIf="!data.shouldHideTime"
                       type="time"
                       formControlName="timeStart">
            </kal-input>

        </kal-form-field>

        <kal-form-field class="date-heure">

            <kal-datepicker formControlName="dateEnd"
                            [label]="data.dateEndLabel">
            </kal-datepicker>

            <kal-input *ngIf="!data.shouldHideTime"
                       type="time"
                       formControlName="timeEnd">
            </kal-input>

        </kal-form-field>

    </div>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        [disabled]="form.invalid"
                        kalTheme="primary">
                Valider
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="close()"
                        kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
